var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.014 6.405-1.702 1.687.558.558a.57.57 0 0 1 0 .806l-.996.99a.758.758 0 0 1-1.074 0l-.434-.434-4.559 4.568a.956.956 0 0 1-.681.28H4.59l-1.63.815a.474.474 0 0 1-.638-.638l.816-1.628v-1.536a.955.955 0 0 1 .28-.682L7.98 6.632l-.571-.565a.57.57 0 0 1 0-.806L8.54 4.13a.57.57 0 0 1 .806 0l.558.558 1.69-1.702a2.418 2.418 0 0 1 3.42 3.42zM10.4 9.052 8.954 7.606l-4.21 4.197a.52.52 0 0 0-.153.369v.715c0 .287.233.52.521.52h.715a.52.52 0 0 0 .368-.153L10.4 9.052z",
    fill: "#848B92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/color-picker.933dcf1e1e673330a3f57bb2c4363d33.svg";
export { ForwardRef as ReactComponent };